const similarAddressTypes = ["mail", "billing", "shipping", "RTV"];

const similarAddressFields = (addressTypes, addressIndex) => {
  return addressTypes.map((type) => {
    const index = !isNaN(addressIndex) ? addressIndex : "";
    const customAddressLabel = `${
      type === "mail" ? "Mailing" : type.charAt(0).toUpperCase() + type.slice(1)
    } Address Street Name`;

    return [
      {
        fieldId: `streetAddress`,
        fieldLabel: customAddressLabel,
        required: true,
        length: 4,
        placeHolder: "151 W 34th street",
        fieldType: "text",
        automationId: `${type.toLowerCase()}Address`,
        key: `streetAddress_${type.toLowerCase()}${index}`,
      },
      {
        fieldId: "suiteUnitFloor",
        fieldLabel: "Unit",
        length: 1,
        required: false,
        placeHolder: "11",
        fieldType: "text",
        automationId: `${type.toLowerCase()}Suite`,
        key: `suiteUnitFloor_${type.toLowerCase()}${index}`,
      },
      {
        fieldId: "city",
        fieldLabel: "City",
        length: 2,
        required: true,
        placeHolder: "New York",
        fieldType: "text",
        automationId: `${type.toLowerCase()}City`,
        key: `city_${type.toLowerCase()}${index}`,
      },
      {
        fieldId: "state",
        fieldLabel: "State/Province",
        length: 2,
        maxLength: 2,
        required: true,
        placeHolder: "NY",
        fieldType: "text",
        automationId: `${type.toLowerCase()}State`,
        key: `state_${type.toLowerCase()}${index}`,
      },
      {
        fieldId: "zipCode",
        fieldLabel: "Zip",
        length: 2,
        required: true,
        placeHolder: "10001",
        fieldType: "text",
        automationId: `${type.toLowerCase()}ZipCode`,
        key: `zipCode_${type.toLowerCase()}${index}`,
      },
      {
        fieldId: "country",
        fieldLabel: "Country",
        length: 1,
        maxLength: 2,
        required: true,
        placeHolder: "US",
        fieldType: "text",
        automationId: `${type.toLowerCase()}Country`,
        key: `country_${type.toLowerCase()}${index}`,
      },
    ];
  });
};

export const otherAddressFields = (addressIndex) =>
  similarAddressFields(["other"], addressIndex);

export const upsAddressFields = (addressIndex) =>
  similarAddressFields(["ups"], addressIndex);

export const defaultAddressFields = () =>
  similarAddressFields(similarAddressTypes);

export const checkBoxes = [
  {
    fieldId: "billingCheckbox",
    fieldLabel: "Billing",
    type: "billingAddress",
  },
  {
    fieldId: "shippingCheckbox",
    fieldLabel: "Shipping",
    type: "shippingAddress",
  },
  {
    fieldId: "rtvCheckbox",
    fieldLabel: "RTV",
    type: "rtvAddress",
  },
];
